require('./common/');
require('./search/');
require('./authentication/');
require('./sliderServices/');
require('./utilities/');
require('./validators/');
require('./sliderWidgets/');
require('./sliderTemplates/');
require('./sliderServicesAll/');
require('./paymentStatus/');
require('./passwordRecovery/');
require('./feedback/');
require('./cardSecure/');
require('./cardsList/');
require('./localization/');
require('./sendReceipt/');
require('./ellipsis/');
require('./click-out/');
require('./calculator/');
require('./sendsms/');
require('./macros/');
require('./cvvKeyboard/');
require('./locationSelect/');
require('./counter/');
require('./script-lang/');
require('./main.baner/');
require('./loader/');
require('./breadcrumbs');
require('./timer');
require('./inputfield');
require('./smsConfirm');
require('./promoterScore');
require('./cardPayBlock');
require('./paymentCheck');
require('./paymentCreate');
require('./paymentConfirm');
require('./paymentFields');
require('./counters');
require('./printReceipt');
require('./metallist');
// require('./tickets');
require('./autocomplete');
require('./booking');
require('./setFocus');
require('./mobileDropdown');
require('./authMasterpass');
require('./masterpassBanner');
require('./creditBanner');
require('./masterpassAuthForm');
require('./mobilePhone');
require('./paymentGroups');
require('./macrosAttr');
require('./bankDetails');
require('./googlePay');
require('./applePay');

// require('./scroll');
/**
 * directives Module
 *
 * Description
 */
var app = angular.module(
    'directives', [
        'directives.authentication',
        'directives.sliderServices',
        'directives.sliderWidgets',
        'directives.script',
        'directives.sliderTemplates',
        'directives.sliderServicesAll',
        'directives.search',
        'directives.clickOutside',
        'directives.utilities',
        'directives.cvvKeyboard',
        'directives.locationSelect',
        'directives.common',
        'directives.paymentstatus',
        'directives.recovery',
        'directives.feedback',
        'directives.cardSecure',
        'directives.sendsms',
        'directives.cardsList',
        'directives.counter',
        'directives.localization',
        'directives.sendreceipt',
        'directives.angular-ellipsis',
        'directives.calculator',
        'directives.macros',
        'directives.banner',
        'component-spinner',
        'directives.breadcrumbs',
        'directives.timer',
        'directives.inputfield',
        'directives.smsConfirm',
        'directives.promoterScore',
        'directives.cardPayBlock',
        'directives.paymentCheck',
        'directives.paymentCreate',
        'directives.paymentConfirm',
        'directives.paymentFields',
        'directives.counters',
        'directives.promoterScore',
        'directives.printReceipt',
        'directives.metallist',
        // 'directives.tickets',
        'directives.autocomplete',
        'directives.booking',
        'directives.setFocus',
        'directives.masterpassBanner',
        'directives.creditBanner',
        'directives.masterpassAuthForm',
        'directives.authMasterpass',
        'directives.mobileDropdown',
        'directives.mobilePhone',
        'directives.paymentGroups',
        'directives.macrosAttr',
        'directives.bankDetails',
        'directives.googlePay',
        'directives.applePay'
    ]
);

module.exports = 'directives';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/index.js
 ** module id = 165
 ** module chunks = 1
 **/